import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=88cd155c&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=ts"
export * from "./previewDialog.vue?vue&type=script&lang=ts"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=88cd155c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cd155c",
  null
  
)

export default component.exports